interface ShouldQueueReconnectArgs {
  canConnect: boolean;
  currentState: string;
}

interface ShouldReportConnectFailureArgs {
  disconnectToReconnect: boolean;
  isFirmwareUpdateState: boolean;
  isNotInitializedState: boolean;
  userCancelledConnection: boolean;
}

export const shouldQueueReconnect = ({ canConnect, currentState }: ShouldQueueReconnectArgs): boolean => {
  return !canConnect && currentState !== 'disconnected';
};

export const shouldReportConnectFailure = ({
  disconnectToReconnect,
  isFirmwareUpdateState,
  isNotInitializedState,
  userCancelledConnection,
}: ShouldReportConnectFailureArgs): boolean => {
  if (disconnectToReconnect || userCancelledConnection) {
    return false;
  }

  return isNotInitializedState && !isFirmwareUpdateState;
};
